// Header.js
import React, { useEffect, useRef, useState } from "react";
import "./Header.css";
import HeaderNav from "../HeaderNav/HeaderNav";
import logo from "../../images/logo.svg";
import { Link } from "react-router-dom";
import NotificationsDropdown from "../Notifications/NotificationsDropdown";

const Header = ({ navItems }) => {
  const headerRef = useRef(null);
  const [isCompact, setIsCompact] = useState(false);
  const isCompactRef = useRef(isCompact);
  const measuringRef = useRef(false);

  useEffect(() => {
    const container = headerRef.current?.querySelector(".header__container");
    const headerElement = headerRef.current;

    if (!container || !headerElement) {
      return;
    }

    const calculateCompact = () => {
      if (measuringRef.current) {
        return;
      }

      measuringRef.current = true;

      try {
        headerElement.dataset.measuring = "true";

        const overflow = container.scrollWidth - container.clientWidth;

        delete headerElement.dataset.measuring;

        const ENTER_THRESHOLD = 4;
        const EXIT_THRESHOLD = -16;

        const needsCompact = isCompactRef.current
          ? overflow > EXIT_THRESHOLD
          : overflow > ENTER_THRESHOLD;

        if (needsCompact !== isCompactRef.current) {
          isCompactRef.current = needsCompact;
          setIsCompact(needsCompact);
        }
      } finally {
        delete headerElement.dataset.measuring;
        measuringRef.current = false;
      }
    };

    const resizeObserver =
      typeof ResizeObserver !== "undefined"
        ? new ResizeObserver(() => {
            window.requestAnimationFrame(calculateCompact);
          })
        : null;

    if (resizeObserver) {
      resizeObserver.observe(container);
    } else {
      window.addEventListener("resize", calculateCompact);
    }

    window.requestAnimationFrame(calculateCompact);

    return () => {
      if (resizeObserver) {
        resizeObserver.disconnect();
      } else {
        window.removeEventListener("resize", calculateCompact);
      }
    };
  }, [navItems]);

  useEffect(() => {
    isCompactRef.current = isCompact;

    if (!isCompact) {
      document.body.classList.remove("_lock");
      const iconMenu = document.querySelector(".menu__icon");
      const navBody = document.querySelector(".nav__body");

      iconMenu?.classList.remove("_active");
      navBody?.classList.remove("_active");
    }
  }, [isCompact]);

  useEffect(() => {
    const iconMenu = document.querySelector(".menu__icon");
    const navBody = document.querySelector(".nav__body");

    const handleClick = (e) => {
      document.body.classList.toggle("_lock");
      iconMenu.classList.toggle("_active");
      navBody.classList.toggle("_active");
    };

    const handleLinkClick = (e) => {
      // Проверяем, что клик был на ссылке навигации (не в подменю)
      const isSubmenuItem = e.target.closest(".nav__submenu-item");
      if (!isSubmenuItem) {
        // При клике на ссылку скрываем меню навигации
        document.body.classList.remove("_lock");
        iconMenu.classList.remove("_active");
        navBody.classList.remove("_active");
      }
    };

    if (iconMenu) {
      iconMenu.addEventListener("click", handleClick);
    }

    // Используем делегирование событий на всей навигации
    if (navBody) {
      navBody.addEventListener("click", handleLinkClick);
    }

    return () => {
      if (iconMenu) {
        iconMenu.removeEventListener("click", handleClick);
      }
      if (navBody) {
        navBody.removeEventListener("click", handleLinkClick);
      }
    };
  }, []);

  return (
    <header
      ref={headerRef}
      className={`header${isCompact ? " header--compact" : ""}`}
    >
      <div className="header__container">
        <div className="header__logo">
          <Link to="/">
            <img src={logo} className="header__logo-img" alt="logo"></img>
          </Link>
          <p className="header__logo-quote">С нами легко строить</p>
        </div>
        <div className="header__nav-and-notifications">
          <HeaderNav navItems={navItems} isCompact={isCompact}></HeaderNav>
          {!isCompact && (
            <div className="header__notifications">
              <NotificationsDropdown />
            </div>
          )}
        </div>
        <div className="header__menu menu">
          {isCompact && (
            <div className="header__notifications header__notifications--compact">
              <NotificationsDropdown />
            </div>
          )}
          <div className="menu__icon">
            <span></span>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
